/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, OnInit} from '@angular/core';
import {ScheduleService} from "../../providers/schedule-service";
import {CompEvent} from "../../models/CompEvent";
import {Observable} from "rxjs/Observable";
import {MenuController, ModalController, NavController} from "ionic-angular";
import {PageRefs} from "../../shared/PageRefs";


@Component({
  selector: 'schedule-menu',
  templateUrl: 'schedule-menu.html'
})
export class ScheduleMenuComponent implements OnInit {

  activeEvent$: Observable<CompEvent>;

  constructor(private modalCtrl: ModalController,
              private menuCtrl: MenuController,
              private scheduleService: ScheduleService) {
  }

  ngOnInit(): void {
    this.activeEvent$ = this.scheduleService.selectedEvent$;
  }

  // region Menu Buttons

  goToAgeCategories() {
    this.modalCtrl.create(PageRefs.programAgeCategories.name).present();
    this.menuCtrl.close();
  }

  goToEntryCategories() {
    this.modalCtrl.create(PageRefs.programEntryCategories.name).present();
    this.menuCtrl.close();
  }

  goToEntryClassifications() {
    this.modalCtrl.create(PageRefs.programEntryClassifications.name).present();
    this.menuCtrl.close();
  }

  goToEntryTypes() {
    this.modalCtrl.create(PageRefs.programEntryTypes.name).present();
    this.menuCtrl.close();
  }

  goToAdjudicators() {
    this.activeEvent$
      .first()
      .subscribe(event => {
        let data = {};
        data[PageRefs.eventAdjudicators.params.eventId] = event.id;

        this.modalCtrl.create(PageRefs.eventAdjudicators.name, data).present();
        this.menuCtrl.close();
      });
  }

  goToStudios() {
    this.modalCtrl.create(PageRefs.programStudios.name).present();
    this.menuCtrl.close();
  }

  goToMedallions() {
    this.modalCtrl.create(PageRefs.programMedallions.name).present();
    this.menuCtrl.close();
  }

  scheduleClicked() {
    // TODO: check if purchased
    this.menuCtrl.close();
  }

  // endregion
  goToAwardTypes() {
    this.modalCtrl.create(PageRefs.programEntryAwards.name).present();
    this.menuCtrl.close();
  }
}



// WEBPACK FOOTER //
// ./src/components/schedule-menu/schedule-menu.ts